<template>
    <i class="text-dark fas fa-landmark" aria-hidden="true"></i>
</template>